import { render } from "./List.vue?vue&type=template&id=47203bb0&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=47203bb0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47203bb0"

export default script